import { render, staticRenderFns } from "./GstReprintDetail.vue?vue&type=template&id=47846560&scoped=true"
import script from "./GstReprintDetail.vue?vue&type=script&lang=js"
export * from "./GstReprintDetail.vue?vue&type=script&lang=js"
import style0 from "./GstReprintDetail.vue?vue&type=style&index=0&id=47846560&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47846560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47846560')) {
      api.createRecord('47846560', component.options)
    } else {
      api.reload('47846560', component.options)
    }
    module.hot.accept("./GstReprintDetail.vue?vue&type=template&id=47846560&scoped=true", function () {
      api.rerender('47846560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gstreport/GstReprintDetail.vue"
export default component.exports